import moment from 'moment'
import currencyFormatter from '../../../utils/currencyFormatter'
import { getRegs } from '../../../utils/fc'
import {
  applyPlaceholders,
  highlightPlaceholders,
  rawToHtml,
} from '../../../pages/GestaoMinutas/minutaRender'

const formatPlaceholderDate = (value) => {
  if (!value) return ''
  const parsed = moment(value)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : String(value)
}

const formatPlaceholderText = (value) => {
  if (value == null) return ''
  return String(value).trim()
}

const findSelectLabel = (options, id) => {
  const normalizedId = Number(id) || 0
  if (!normalizedId || !Array.isArray(options)) return ''
  const found = options.find((option) => Number(option.value) === normalizedId)
  return formatPlaceholderText(found?.label)
}

const resolveContratanteLabel = async (contrFornData = {}, selContratantes = []) => {
  const contratanteId = Number(contrFornData.contrForn_contratante) || 0
  if (!contratanteId) return ''

  try {
    const [pj] = await getRegs('pj', { pj_id: contratanteId })
    if (pj?.pj_razaosocial) return formatPlaceholderText(pj.pj_razaosocial)
  } catch (error) {
    console.error('Erro ao resolver contratante_label:', error)
  }

  return findSelectLabel(selContratantes, contratanteId)
}

const resolveContratadaLabel = async (
  contrFornData = {},
  { selPfsFornecedor = [], selPjsFornecedor = [] } = {},
) => {
  const parteTab = String(contrFornData.contrForn_parteTab || '').trim().toLowerCase()
  const parteId = Number(contrFornData.contrForn_parteId) || 0
  if (!parteId || (parteTab !== 'pf' && parteTab !== 'pj')) return ''

  if (parteTab === 'pf') {
    const fromSelect = findSelectLabel(selPfsFornecedor, parteId)
    if (fromSelect) return fromSelect

    try {
      const [pf] = await getRegs('pf', { pf_id: parteId })
      return formatPlaceholderText(pf?.pf_nomeExibicao)
    } catch (error) {
      console.error('Erro ao resolver contratada_label (pf):', error)
      return ''
    }
  }

  const fromSelect = findSelectLabel(selPjsFornecedor, parteId)
  if (fromSelect) return fromSelect

  try {
    const [pj] = await getRegs('pj', { pj_id: parteId })
    return formatPlaceholderText(pj?.pj_razaosocial)
  } catch (error) {
    console.error('Erro ao resolver contratada_label (pj):', error)
    return ''
  }
}

/**
 * Mapa {{campo}} → valor para o domínio contrForn.
 * - contratante_label = pj_razaosocial de contrForn_contratante
 * - contratada_label = pf_nomeExibicao (pf) ou pj_razaosocial (pj) de parteTab/parteId
 * - contrForn_obj = informacoes_contrato.objeto_resumido do compraCotacao_info
 */
export async function buildContrFornPlaceholderContext(
  contrFornData = {},
  {
    selContratantes = [],
    selPfsFornecedor = [],
    selPjsFornecedor = [],
    compraCotacaoInfo = null,
  } = {},
) {
  const [contratanteLabel, contratadaLabel] = await Promise.all([
    resolveContratanteLabel(contrFornData, selContratantes),
    resolveContratadaLabel(contrFornData, { selPfsFornecedor, selPjsFornecedor }),
  ])

  const valorGlobal = Number(contrFornData.contrForn_vlrGlobal)
  const valorGlobalLabel = Number.isFinite(valorGlobal)
    ? currencyFormatter.format(valorGlobal)
    : formatPlaceholderText(contrFornData.contrForn_vlrGlobal)

  const objetoResumido = formatPlaceholderText(
    compraCotacaoInfo?.informacoes_contrato?.objeto_resumido,
  )

  return {
    contratante_label: contratanteLabel,
    contratada_label: contratadaLabel,
    contrForn_obj: objetoResumido,
    contrForn_dtAssin: formatPlaceholderDate(contrFornData.contrForn_dtAssin),
    contrForn_dtVigIni: formatPlaceholderDate(contrFornData.contrForn_dtVigIni),
    contrForn_dtVigFim: formatPlaceholderDate(contrFornData.contrForn_dtVigFim),
    contrForn_vlrGlobal: valorGlobalLabel,
    contrForn_dataPagamento: formatPlaceholderText(contrFornData.contrForn_dataPagamento),
  }
}

/** HTML do corpo com placeholders resolvidos; os restantes ficam destacados. */
export function renderMinutaBodyHtml(body, placeholderContext = null) {
  let html = rawToHtml(body)
  if (placeholderContext) {
    html = applyPlaceholders(html, placeholderContext)
  }
  return highlightPlaceholders(html)
}
